<template>
<div>
    <b-row>
        <b-col cols="12">
            <img class="mr-2" src="/static-appopensalud/img/icons/billing-grey.svg" height="30" width="30" />
            <h4 class="billing-title" v-html="$t('payments.billingData')"></h4>
        </b-col>
        <hr>
        <b-col class="mb-4" cols="12">
            <div v-html="$t('payments.billingInfo')"></div>
        </b-col>
        <b-col cols="12">
            <label v-html="$t('payments.billingEntity')"></label>
            <base-input v-model="paymentInfo.billingEntity.value" @blur="checkFieldState('billingEntity')" :state="paymentInfo.billingEntity.valid"></base-input>
        </b-col>
        <b-col cols="12">
            <label v-html="$t('payments.billingAddress')"></label>
            <base-input v-model="paymentInfo.address.value" @blur="checkFieldState('address')" :state="paymentInfo.address.valid"></base-input>
        </b-col>
        <b-col cols="12" md="5">
            <label v-html="$t('payments.billingNif')"></label>
            <base-input v-model="paymentInfo.nif.value" @blur="checkFieldState('nif')" :state="paymentInfo.nif.valid"></base-input>
        </b-col>
        <b-col class="mb-4" cols="12" md="5" offset-md="2">
            <label v-html="$t('payments.billingCountry')"></label>
            <base-select searchable :options="countryOptions" valueProp="idCountry" :label="$i18nHelpers.normalizeProp('name')" @option:selected="countryChange" v-model="paymentInfo.country.value" :state="paymentInfo.country.valid"></base-select>
        </b-col>
        <b-col class="mb-4" cols="12">
            <label v-html="$t('payments.billingProvince')"></label>
            <base-select searchable :options="stateOptions" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" @option:selected="stateChange" v-model="paymentInfo.state.value" :state="paymentInfo.state.valid"></base-select>
        </b-col>
        <b-col class="mb-4" cols="12" md="5">
            <label v-html="$t('payments.billingVillage')"></label>
            <base-select searchable :loading="false" :options="cityOptions" valueProp="idCity" :label="$i18nHelpers.normalizeProp('name')" @option:selected="cityChange" v-model="paymentInfo.city.value" :state="paymentInfo.city.valid"></base-select>
        </b-col>
        <b-col cols="12" md="5" offset-md="2">
            <label v-html="$t('payments.billingPostalCode')"></label>
            <base-input v-model="paymentInfo.postCode.value" @blur="checkFieldState('postCode')" :state="paymentInfo.postCode.valid"></base-input>
        </b-col>
    </b-row>
    <b-row class="mt-5">
        <b-col cols="12" class="text-center">
            <back-button withoutArrow :action="() => $emit('back')" class="mr-3"></back-button> <base-button @click="sendBillingData">{{ $t('continue') }}</base-button>
        </b-col>
    </b-row>
</div>
</template>

<script>
import BaseButton from '../base/buttons/BaseButton'
import BackButton from '../base/buttons/BackButton'
import geographyRepository from '@/repositories/GeographyRepository'
import billingRepository from '@/repositories/BillingRepository'
import { MX_COUNTRY_ID, SPAIN_COUNTRY_ID } from '@/constants/db/countries'
import { MX_LOCALE } from '@/constants/locales'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'payments'

export default {
    components: {
        BaseButton,
        BackButton
    },
    mixins: [i18nMixin(I18N_FILE)],
    created () {
        // TODO: when profesional payments, hide billingStep
        this.loadCountries()
        billingRepository.getPatientBillingInfo().then(response => {
            let data = response.data.data
            Object.keys(data).forEach(key => { this.paymentInfo[key].value = data[key] })
            if (!this.paymentInfo.country.value) this.paymentInfo.country.value = this.$i18n.locale === MX_LOCALE ? MX_COUNTRY_ID : SPAIN_COUNTRY_ID
            this.loadStates()
            if (this.paymentInfo.state.value) this.loadCities()
        })
    },
    data () {
        return {
            countryOptions: [],
            stateOptions: [],
            cityOptions: [],
            paymentInfo: {
                billingEntity: { value: null, valid: null },
                address: { value: null, valid: null },
                country: { value: null, valid: true },
                nif: { value: null, valid: null },
                state: { value: null, valid: null },
                city: { value: null, valid: null },
                postCode: { value: null, valid: null }
            }
        }
    },
    methods: {
        loadCountries () {
            return geographyRepository.getCountries().then((response) => {
                this.countryOptions = response.data
            })
        },
        loadStates () {
            return geographyRepository.getStatesByCountry(this.paymentInfo.country.value).then((response) => {
                this.stateOptions = response.data
            })
        },
        loadCities () {
            return geographyRepository.getStateCities(this.paymentInfo.state.value).then((response) => {
                this.cityOptions = response.data
            })
        },
        countryChange () {
            this.loadStates()
            this.cityOptions = []
            this.paymentInfo.state.value = null
            this.paymentInfo.city.value = null
            this.paymentInfo.state.valid = null
            this.paymentInfo.city.valid = null
        },
        stateChange () {
            this.paymentInfo.city.value = null
            this.paymentInfo.state.valid = true
            this.loadCities()
        },
        cityChange () {
            this.paymentInfo.city.valid = true
        },
        checkFieldState (field) {
            this.paymentInfo[field].valid = !!this.paymentInfo[field].value
        },
        sendBillingData () {
            Object.keys(this.paymentInfo).forEach(key => {
                let item = this.paymentInfo[key]
                item.valid = !!item.value
            })
            if (Object.keys(this.paymentInfo).some(key => !this.paymentInfo[key].valid)) return
            let values = {}
            Object.keys(this.paymentInfo).forEach(key => { values[key] = this.paymentInfo[key].value })
            billingRepository.savePatientBillingInfo(values).then(response => {
                if (response.data.data) {
                    this.$emit('nextStep')
                } else {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.billing-title{
    display: inline-block;
    margin-bottom: 0;
}
.align-right{
    text-align: right;
}
.align-center{
    align-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/payment/PaymentBillingInfo.vue